import { Grid, Typography } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

dayjs.locale('es');

import { Contrato, Rubro } from '@/shared/interfaces';

export type ClienteRubroCardHeaderProps = {
  rubro: Rubro;
  contract: Contrato;
};

const ClienteRubroCardHeader: React.FC<ClienteRubroCardHeaderProps> = ({
  contract,
  rubro,
}) => {
  const customerName = contract?.cliente_data?.razon_social;
  const customerAddress = contract?.direccion;
  const customerPhone = contract?.celular;
  const customerMobile = contract?.celular_2;

  const emitterName = contract?.empresa_create_data?.razon_social;
  const emitterAddress = contract?.empresa_create_data?.direccion;
  const emitterPhone = contract?.empresa_create_data?.telefono_1;

  return (
    <Grid
      item
      container
      xs={12}
      spacing={2}
      sx={{
        mb: 6,
        mt: 2,
        pl: 2,
      }}
    >
      {/* ----- de ----- */}
      <Grid item xs={12} md={4}>
        <Typography variant="body1">De</Typography>
        <Typography variant="body1" fontWeight="bold">
          {emitterName}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {emitterAddress}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {emitterPhone}
        </Typography>
      </Grid>

      {/* ----- para ----- */}
      <Grid item xs={12} md={4}>
        <Typography variant="body1">Para</Typography>
        <Typography variant="body1" fontWeight="bold">
          {customerName}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {customerAddress}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {customerPhone}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {customerMobile}
        </Typography>
      </Grid>

      {/* ----- fecha emision & vencimiento ----- */}
      <Grid item xs={12} md={4} container pr={3}>
        <Grid item>
          <Typography variant="body2" color="textSecondary" textAlign="end">
            Emitido: {dayjs(rubro.fecha_emision).format('D MMMM YYYY')}
          </Typography>

          <Typography variant="body1" fontWeight="bold" textAlign="end">
            {dayjs(rubro.fecha_vencimiento).format('D MMMM YYYY')}
          </Typography>

          <Typography variant="body1" fontWeight="bold" textAlign="end">
            N° {rubro.numero_referencia}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ClienteRubroCardHeader;
